import { render, staticRenderFns } from "./FormAvatar.vue?vue&type=template&id=9a3bbd7c&scoped=true&"
import script from "./FormAvatar.vue?vue&type=script&lang=js&"
export * from "./FormAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3bbd7c",
  null
  
)

export default component.exports